import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import vatActions from '../actions/vatInformation';

// Middleware function
function getVatMetadata(store) {
    request.get(`/${config.url_prefix}/api/vatMetadata?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(vatActions.alertError(errorKey));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.statusCode >= 400 || parsedResponse.code >= 400) {
                        store.dispatch(vatActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else {
                        store.dispatch(vatActions.getVatMetadataSuccess(parsedResponse));
                        store.dispatch(actions.enableLoadOverLay(false));
                    }
                } catch (exp) {
                    store.dispatch(vatActions.alertError('ipmob.error.process.request'));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
        });
}

export default getVatMetadata;
